import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueRouter, { RouteConfig } from 'vue-router'

import { store } from '@/store'
import RootView from './Root.vue'

import i18n from '@/i18n'

Vue.use( VueRouter )
Vue.use( VueMeta )

function loadComponent( component: any ) {
    return () => import(`@/views/${component}.vue`)
}

const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: i18n.locale
    },
    {
        path: '/:locale',
        component: RootView,
        children: [
            {
                path: '',
                name: 'Home',
                component: loadComponent( 'Home' )
            },
            {
                path: 'explorer',
                name: 'Explorer',
                component: loadComponent( 'Explorer' )
            },
            {
                path: 'images',
                name: 'Images',
                component: loadComponent( 'Images' )
            },
            {
                path: 'associations',
                name: 'Associations',
                component: loadComponent( 'Associations' )
            },
            {
                path: 'users',
                name: 'Users',
                component: loadComponent( 'Users' )
            },
            {
                path: 'login',
                name: 'Login',
                component: loadComponent( 'Login' )
            },
            {
                path: 'welcome',
                name: 'Welcome',
                component: loadComponent( 'Welcome' )
            },
            {
                path: 'help',
                name: 'Help',
                component: loadComponent( 'Help' )
            },
            {
                path: 'imprint',
                name: 'Imprint',
                component: loadComponent( 'Imprint' )
            },
            {
                path: 'privacy',
                name: 'Privacy',
                component: loadComponent( 'Privacy' )
            },
            {
                path: '*',
                redirect: {
                    name: 'Home'
                }
            }
        ]
    },
    {
        path: '*',
        redirect() {
            return i18n.locale
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
} )

router.beforeEach( ( to, from, next ) => {
    const locale = to.params.locale
    const supportedLocales = ['en','de']

    if ( !supportedLocales.includes( locale ) ) return next( 'en' )

    if ( i18n.locale !== locale ) {
        i18n.locale = locale
    }

    return next()
} )

router.afterEach( ( to, from ) => {
    store.commit( 'globalModule/removeFixedBody' )
} )

export default router
